import { Component, Input } from '@angular/core';
import { ContentMessagingInfoComponent } from '../content-messaging-info/content-messaging-info.component';

@Component({
  selector: 'dx-content-messaging-card',
  standalone: true,
  imports: [ContentMessagingInfoComponent],
  templateUrl: './content-messaging-card.component.html'
})
export class ContentMessagingCardComponent {
  @Input()
  public title: string;
  @Input()
  public description?: string;
  @Input()
  public showPhone: boolean;
  @Input()
  public showAddress: boolean;
  @Input()
  public showEmail: boolean;
  @Input()
  public phoneLabel?: string;
  @Input()
  public emailLabel?: string;
  @Input()
  public addressLabel?: string;
}
